import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { CoreModule } from '../../core/core.module';
import { DocumentosListAtestComponent } from './documentos/documentos-list.component';
import { DocumentosService } from './documentos/documentos.service';
import { ResumenAtestFitoListComponent } from './resumen/resumen-list.component';
import { ResumenAtestFitoService } from './resumen/resumen-list.service';
import { TextoEditComponent } from './texto/texto-edit.component';
import { TextoService } from './texto/texto.service';
import { DocumentosAtestEditComponent } from './documentos/documentos-edit.component';
import { SolicitudAtestFitoEditComponent } from './datosbasicos/solicitudAtestFito-edit.component';
import { SolicitudAtestFitoService } from './datosbasicos/datosbasicosAtestFito.service';
import { TipoSolicitudAtestFitoListComponent } from './tipossolicitudes/tiposolicitudAtestFito-list.component';
import { EnvioAtestFitoComponent } from './envio/envioAtestFito.component';
import { EnvioAtestFitoService } from './envio/envioAtestFito.service';
import { LugarProduccionService } from './lugarproduccion/lugarproduccion.service';
import { LugarProduccionComponent } from './lugarproduccion/lugarproduccion.component';
import { ResultadoService } from './resultado/resultado.service';
import { ResultadoComponent } from './resultado/resultado.component';
import { ProductosAtestFitoService } from './productos/productosAtestFito.service';
import { ProductosAtestFitoListComponent } from './productos/productosAtestFito-list.component';
import { ProductoAtestFitoEditComponent } from './productos/productosAtestFito-edit.component';
import { AnulacionAtestFitoEditComponent } from './anulacion/anulacionAtestFito-edit.component';
import { AtestacionesRoutingModule } from './atestaciones-routing.module';

@NgModule({
    declarations: [
        SolicitudAtestFitoEditComponent,
        TipoSolicitudAtestFitoListComponent,
        ProductosAtestFitoListComponent,
        ProductoAtestFitoEditComponent,
        DocumentosListAtestComponent,
        DocumentosAtestEditComponent,
        TextoEditComponent,
        LugarProduccionComponent,
        ResultadoComponent,
        AnulacionAtestFitoEditComponent,
        EnvioAtestFitoComponent,
        ResumenAtestFitoListComponent,
    ],
    exports: [],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, AtestacionesRoutingModule],
    providers: [
        SolicitudAtestFitoService,
        ProductosAtestFitoService,
        DocumentosService,
        ResumenAtestFitoService,
        TextoService,
        LugarProduccionService,
        ResultadoService,
        EnvioAtestFitoService,
    ],
})
export class AtestacionesModule {}
